import React, { FC } from "react";
import { Box } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import DatePicker from 'UI/DatePicker/DatePicker'
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

interface IAutoCompleteProps{
    from?: Date | null,
    to?: Date | null
    onChangeFrom: (
        event: MaterialUiPickersDate
    ) => void,
    onChangeTo: (
        event: MaterialUiPickersDate
    ) => void,
    type?: string,
    fromLabel?: string,
    toLabel?: string,
    format?: string,
    invalidDateMessage?: string,
    containerWidth?: number | string
}

const DateRangeComponent: FC<IAutoCompleteProps> = ({
    from = null,
    to = null,
    onChangeFrom,
    onChangeTo,
    type = "keyboard",
    fromLabel = "From",
    toLabel = "To",
    format = 'MM/dd/yyyy',
    invalidDateMessage = 'MM/DD/YYYY',
    containerWidth = '100%'
}) => {


    return (
        <Box display="flex" alignItems="center" width={containerWidth}>
            <Typography color="textSecondary">Date:</Typography>     
            <Box ml="1rem" flex={1}>
                <DatePicker
                    fullWidth
                    label={fromLabel}
                    value={from}
                    {...(to != null && { maxDate: to })}
                    type={type}
                    format={format}
                    invalidDateMessage={invalidDateMessage}
                    onChange={onChangeFrom}
                />
            </Box>     
            <Box ml="0.5rem" alignSelf="flex-start" flex={1}>
                <DatePicker
                    fullWidth 
                    label={toLabel}
                    value={to}
                    type={type}
                    format={format}
                    invalidDateMessage={invalidDateMessage}
                    onChange={onChangeTo}
                />
            </Box>
        </Box>
    )
}

export default DateRangeComponent